// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"45696b27","37":"277fb913","45":"12b2da02","126":"12f4a489","147":"efd96cfd","171":"48923270","374":"3c935389","466":"cc9a714f","488":"211b2766","507":"bf866114","553":"84dbc45a","780":"3c8a89cd"}[chunkId] + ".chunk.js";
};